module.exports = __webpack_public_path__ + "img/pic1.5ad4d2c3.png";